import React, { SFC } from "react";

export interface Props {
  icon?: string;
}

export const PersonalTaxFormTitle: SFC<Props> = ({ children, icon }) => {
  return (
    <div className="titel">
      <h1>
        {icon && <i className={`fa fa-${icon}`}></i>} {children}
      </h1>
    </div>
  );
};

PersonalTaxFormTitle.displayName = "PersonalTaxFormTitle";
